module.exports = __webpack_public_path__ + "static/media/IMG_1860.a1e1970d.JPG";